import { gql } from '@apollo/client';

const SAVE_SIGNATURE_MUTATION = gql`
  mutation saveSignature($signature: String!) {
    saveSignature(signature: $signature) {
      isSuccess
      message
      signature
    }
  }
`;

export default SAVE_SIGNATURE_MUTATION;
